"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * @file injectIframe.ts 向body插入一个iframe
 * @author wangning25 <wangning25@baidu.com> on 2021/10/06.
 */

/**
 * 向body插入一个iframe
 * @param url URL地址
 * @returns {boolean}
 */
var injectIframe = function injectIframe(url) {
  var ifr = document.createElement('iframe');
  ifr.src = url;
  ifr.style.display = 'none';
  document.body.appendChild(ifr);
  setTimeout(function () {
    document.body.removeChild(ifr);
    ifr = null;
  }, 0);
  return true;
};

var _default = injectIframe;
exports.default = _default;